export enum TRAVEl_TODOS_VIEWS {
  TEAM = 'team_mng_view',
  DPT = 'dpt_mng_view',
  BTAT = 'btat_mng_view',
  ACCOUNTING = 'accounting_mng_view',
}
